import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

if (window.location.pathname.startsWith('/kiosk')) {
  // Kiosk path — skip MSAL entirely, render standalone status board
  void import('./pages/KioskStatusPage').then(({ KioskStatusPage }) => {
    ReactDOM.createRoot(root).render(
      <React.StrictMode>
        <KioskStatusPage />
      </React.StrictMode>,
    );
  });
} else {
  void import('./shared/msal')   // initialise MSAL before app renders
    .then(() => import('./App'))
    .then(({ App }) => {
      ReactDOM.createRoot(root).render(
        <React.StrictMode>
          <App />
        </React.StrictMode>,
      );
    });
}
